import { Id, Schedule, Store } from '@nextforce/api'
import { StackNavigationProp } from '@react-navigation/stack'
import { HandleNavigationProp } from 'app/routing_context'
import { HomeStackParamList } from 'home/stack/types'
import { groupBy } from 'lodash'
import {
  ShowEventsOptionProps,
  ShowSummaryTilesOptionProps,
  ShowWeeklySummaryOptionProps,
} from 'shared/components/dropdown'
import { showHeaderTitleDropdown } from 'shared/header/header_title_dropdown'
import { getScheduleName, isSameSchedule } from './schedules'

function getScheduleSections(
  schedules: Schedule[],
  stores: Store[],
  activeStoreId?: Id
) {
  const items = schedules.map((schedule, index) => ({
    ...schedule,
    id: index,
    name: getScheduleName(schedule, false, stores),
  }))

  if (activeStoreId) {
    return [
      {
        title: undefined,
        data: items.filter(
          item => item.calendar === 'helper' || item.storeId === activeStoreId
        ),
      },
    ]
  }

  const scheduleGroups = groupBy(items, schedule => {
    if (schedule.calendar === 'store') {
      const store = stores.find(s => s.id === schedule.storeId)
      return store?.storeNumber ?? ''
    }

    return ''
  })

  return Object.keys(scheduleGroups)
    .sort()
    .map(storeNumber => ({
      title: String(storeNumber),
      data: scheduleGroups[storeNumber],
    }))
}

export function showScheduleHeaderDropdown(
  schedules: Schedule[],
  currentSchedule: Schedule | undefined,
  navigation: StackNavigationProp<HomeStackParamList>,
  handleNavigation: <RouteName extends keyof HomeStackParamList>({
    routeName,
    routeParams,
  }: HandleNavigationProp<RouteName>) => void,
  onScheduleChange: (schedule: Schedule) => void,
  activeFilterNames: () => string,
  stores: Store[],
  showWeeklySummaryOptionProps: ShowWeeklySummaryOptionProps,
  showSummaryTilesOptionProps: ShowSummaryTilesOptionProps,
  showEventsOptionProps: ShowEventsOptionProps,
  activeStoreId?: Id,
  showCustomFilters?: boolean
) {
  const scheduleSections = currentSchedule
    ? getScheduleSections(schedules, stores, activeStoreId)
    : []

  const index = currentSchedule
    ? schedules.findIndex(schedule => isSameSchedule(schedule, currentSchedule))
    : -1

  showHeaderTitleDropdown(
    navigation,
    scheduleSections,
    index,
    selectedIndex => {
      const schedule = schedules[selectedIndex]
      if (schedule.custom) {
        handleNavigation({ routeName: 'filter_chooser' })
      } else {
        onScheduleChange(schedule)
      }
    },
    {
      showEventsOptionProps,
      showWeeklySummaryOptionProps,
      showSummaryTilesOptionProps,
    },
    activeFilterNames,
    showCustomFilters
  )
}
